import { Divider, Switch, Typography } from 'antd';
import styles from './BalanceHeader.module.css';
import { AppContext } from '../../../App';
import React, { useContext, useEffect } from 'react';

interface Props {
  children?: any;
}

const BalanceHeader: React.FC<Props> = ({ children }) => {
  const { setIsAmountVisible, isAmountVisible }: any = useContext(AppContext);

  const { Text } = Typography;

  const onChange = (checked: boolean) => {
    setIsAmountVisible(checked);
  };
  useEffect(() => {
    window.onpopstate = () => {
      window.history.pushState(null, '', window.location.href);
    };
  }, []);

  return (
    <>
      <div className={styles.balanceHeaderTitle}>
        <Text style={{ fontSize: 10, fontWeight: 500, color: 'var(--ct-text-muted)' }}>
          Tap to hide balances
        </Text>

        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          <Text style={{ color: 'var(--ct-text-muted)', fontSize: 10 }}>Hide</Text>
          <Switch size='small' value={isAmountVisible} onChange={onChange} />
          <Text style={{ color: 'var(--ct-text-primary)', fontSize: 10, fontWeight: 600 }}>
            Show
          </Text>
        </div>
      </div>
      <div className={styles.assestsRoot}>{children}</div>
    </>
  );
};

export default BalanceHeader;
